import { render, staticRenderFns } from "./VideoRoomContainer.vue?vue&type=template&id=56855cf0&scoped=true"
import script from "./VideoRoomContainer.vue?vue&type=script&lang=js"
export * from "./VideoRoomContainer.vue?vue&type=script&lang=js"
import style0 from "./VideoRoomContainer.vue?vue&type=style&index=0&id=56855cf0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56855cf0",
  null
  
)

export default component.exports